<ng-container *transloco="let t">
  <div>
    <nz-page-header nzBackIcon class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title *ngIf="isAdd" class="text-primary">
        {{ t('agents.addEdit.addTitle') }}
      </nz-page-header-title>
      <nz-page-header-title *ngIf="!isAdd" class="text-primary">
        {{ t('agents.addEdit.editTitle') }}
      </nz-page-header-title>
    </nz-page-header>
  </div>

  <div class="my-8">
    <div [ngClass]="!isAdd ? 'grid xl:grid-cols-1' : 'grid xl:grid-cols-3 md:grid-cols-2'">
      <div [ngClass]="!isAdd ? 'flex flex-row gap-5' : ''">
        <form nz-form [formGroup]="agentForm">
          <nz-form-item class="lg:flex flex-row">
            <nz-form-label
              class="w-3/12 md:w-3/6 lg:w-2/4"
              nzRequired
              nzFor="name">
              {{ t('agents.addEdit.agencyName') }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="nameCheck">
              <input
                type="text"
                nz-input
                class="w-full"
                formControlName="name"
                [placeholder]="t('agents.addEdit.placeholders.agencyName')" />
            </nz-form-control>
            <ng-template #nameCheck>
              <span *ngIf="formErrors.name.required">
                {{ t('agents.addEdit.errors.agencyNameRequired') }}
              </span>
            </ng-template>
          </nz-form-item>
        </form>

        <div class="flex justify-end">
          <ng-container *ngIf="isAdd">
            <button
              nz-button
              nzType="primary"
              *appHasAnyPrivilege="'AGENT.ADD'"
              [disabled]="agentForm.invalid"
              (click)="addAgent()"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="user-plus" class="icon-size"></lucide-icon>
              {{ t('agents.addEdit.buttons.add') }}
            </button>
          </ng-container>

          <ng-container *ngIf="!isAdd">
            <button
              nz-button
              nzType="primary"
              [disabled]="agentForm.invalid"
              (click)="editAgent()"
              *appHasAnyPrivilege="'AGENT.EDIT'"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="user-pen" class="icon-size"></lucide-icon>
              {{ t('agents.addEdit.buttons.save') }}
            </button>
          </ng-container>
        </div>
      </div>

      <div class="max-w-[33rem]">
        <nz-alert
          *ngIf="actionMessage.display && actionMessage.isAdd"
          [nzType]="actionMessage.type"
          [nzMessage]="actionMessage.message"
          nzShowIcon
          nzCloseable></nz-alert>
      </div>
    </div>

    <div class="grid grid-cols-1 mt-7" *appHasAnyPrivilege="'AGENT.CONTACT.VIEW'">
      <div *ngIf="!this.isAdd">
        <nz-page-header class="bg-slate-100" [nzGhost]="false">
          <nz-page-header-title class="text-primary">
            {{ t('agents.contactsTitle') }}
          </nz-page-header-title>
          <nz-page-header-extra>
            <nz-space class="flex flex-col-reverse md:flex-row justify-end">
              <div class="pe-3 mt-3 md:mt-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
                  <input
                    type="text"
                    nz-input
                    [placeholder]="t('agents.addEdit.placeholders.searchByName')"
                    (keydown.enter)="this.search()"
                    [(ngModel)]="contactSearch" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                  <span
                    *ngIf="contactSearch"
                    nz-icon
                    class="ant-input-clear-icon"
                    nzTheme="fill"
                    nzType="close-circle"
                    (click)="reset()"></span>
                </ng-template>
                <ng-template #suffixButton>
                  <button
                    nz-button
                    nzType="primary"
                    nzSearch
                    (click)="search()">
                    {{ t('agents.searchBtn') }}
                  </button>
                </ng-template>
              </div>
              <div>
                <button
                  *appHasAnyPrivilege="'AGENT.CONTACT.ADD'"
                  nz-button
                  nzType="primary"
                  (click)="this.addEditContact(this.singleAgent, 'new')"
                  class="flex items-center justify-center gap-2">
                  <lucide-icon name="contact" class="icon-size"></lucide-icon>
                  {{ t('agents.addEdit.buttons.addContact') }}
                </button>
              </div>
            </nz-space>
          </nz-page-header-extra>
        </nz-page-header>

        <div class="my-4">
          <nz-table
            #basicTable
            [nzData]="allContacts"
            [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions"
            [nzBordered]="true"
            [nzFrontPagination]="false"
            [nzTotal]="pageSize.length"
            [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex"
            (nzQueryParams)="onTableParamsChange($event)"
            [nzScroll]="{ x: '1100px' }">
            <thead>
              <tr>
                <th [nzSortFn]="sortColumn.compareName" nzWidth="200px">
                  {{ t('agents.contactTable.name') }}
                </th>
                <th [nzSortFn]="sortColumn.compareName" nzWidth="200px">
                  {{ t('agents.contactTable.email') }}
                </th>
                <th [nzSortFn]="sortColumn.compareName" nzWidth="200px">
                  {{ t('agents.contactTable.contactNo') }}
                </th>
                <th [nzSortFn]="sortColumn.compareDate" nzWidth="120px">
                  {{ t('agents.contactTable.createdDate') }}
                </th>
                <th nzWidth="170px" *appHasAnyPrivilege="'AGENT.CONTACT.EDIT'">
                  {{ t('agents.contactTable.action') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of basicTable.data">
                <td class="capitalize">{{ data.name }}</td>
                <td>{{ data.email }}</td>
                <td>{{ data.dialCode }} {{ data.contactNo }}</td>
                <td>{{ data.createdAt | date }}</td>
                <td *appHasAnyPrivilege="'AGENT.CONTACT.EDIT'">
                  <button
                    *appHasAnyPrivilege="'AGENT.CONTACT.EDIT'"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="this.addEditContact(this.singleAgent, 'edit', data)"
                    class="mr-4 flex items-center justify-center gap-2">
                    <lucide-icon name="pencil" class="icon-size"></lucide-icon>
                    {{ t('agents.editBtn') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </div>
  </div>
</ng-container>